import { render, staticRenderFns } from "./kut.vue?vue&type=template&id=57c6978a&scoped=true"
import script from "./kut.vue?vue&type=script&lang=js"
export * from "./kut.vue?vue&type=script&lang=js"
import style0 from "./kut.vue?vue&type=style&index=0&id=57c6978a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c6978a",
  null
  
)

export default component.exports